'use strict';

angular.module('core').controller('SignupStatusController', ['$scope', 'Authentication', 'MobileAppSignupStatus', 'MobileApps', '$stateParams', '$state',
	function($scope, Authentication, MobileAppSignupStatus, MobileApps, $stateParams, $state) {
        $scope.authentication = Authentication;
        // Signup status controller logic
        // ...

        $scope.signedUp = true;
        $scope.billingSubmitted = false;
        $scope.planSubscribed = false;
        $scope.hideMe = true;
		// A second hide property so that we can show/hide it on specific
		// pages without having the need to query the status from the server
		// on every page load
		$scope.stateHideMe = false;
		
		$scope.teamMembers = [];
		$scope.roleInApp = undefined;
		$scope.isOwner = false;

		// States in which we do not want to display the SignupStatus
		$scope.hideStates = [
			'createMobileApp',
			'docs',
			'faq',
			'onboarding',
			'onboarding-upload',
			'viewLanguage',
			'viewLanguage.entry',

			'viewLanguage.entry.edit',
			'viewLanguage.entry.new',
			'viewLanguage.entry.tags',
			'viewLanguage.entry.tags.edit',
			'viewLanguage.entry.tags.new',
			'viewLanguage.entry.tag',
			'viewLanguage.entry.tag.edit',
			'viewLanguage.entry.tag.new',
			'viewLanguage.entry.files',
			'viewLanguage.entry.files.edit',
			'viewLanguage.entry.files.new',
			'viewLanguage.entry.file',
			'viewLanguage.entry.file.edit',
			'viewLanguage.entry.file.new',

			'viewLanguage.entry.state',
			'viewLanguage.entry.state.edit',
			'viewLanguage.entry.state.new',
			'viewLanguage.entry.tags.state',
			'viewLanguage.entry.tags.state.edit',
			'viewLanguage.entry.tags.state.new',
			'viewLanguage.entry.tag.state',
			'viewLanguage.entry.tag.state.edit',
			'viewLanguage.entry.tag.state.new',
			'viewLanguage.entry.files.state',
			'viewLanguage.entry.files.state.edit',
			'viewLanguage.entry.files.state.new',
			'viewLanguage.entry.file.state',
			'viewLanguage.entry.file.state.edit',
			'viewLanguage.entry.file.state.new'
		];

		$scope.getMobileApp = function(callback){
			MobileApps.get({
				mobileAppId: $stateParams.mobileAppId
			}, 	function (response) {
					return callback(null, response);
			}, 	function (errResponse) {
					return callback(errResponse);
			});
		};

		$scope.getMobileAppSignupStatus = function(callback){
			MobileAppSignupStatus.get({ 
				mobileAppId: $stateParams.mobileAppId 
			}, 	function (response){
					return callback(null, response);
				},
				function (errResponse){
					return callback(errResponse);
				}
			);
		};

        $scope.init = function() {
            if($scope.authentication.user && $scope.authentication.user._id)
            {
				if ($stateParams.mobileAppId) {
					async.parallel({
						mobileApp: $scope.getMobileApp,
						signupStatus: $scope.getMobileAppSignupStatus
					}, function(err, result){
						if(err){
							return;
						}

						// Getting current user role
						$scope.teamMembers = result.mobileApp.team.members;
						var userId = $scope.authentication.user._id;
						for (var i = 0; i < $scope.teamMembers.length; i++) {
							if (userId === $scope.teamMembers[i].user) {
								$scope.roleInApp = $scope.teamMembers[i].role;
								$scope.isOwner = ($scope.roleInApp === 'owner');
							}
						}

						// We are in an app so check the app billing information
						$scope.emailVerified = result.signupStatus.emailVerified;
						$scope.billingSubmitted = result.signupStatus.billingSubmitted;
						$scope.planSubscribed = result.signupStatus.planSubscribed;
						$scope.setVisibility();
					});
				} else {
					$scope.emailVerified = $scope.authentication.user.emailVerified;

					if ($scope.authentication && $scope.authentication.user && $scope.authentication.user._billing) {
						$scope.billingSubmitted = $scope.authentication.user._billing.billingDataEntered;
						var planId = $scope.authentication.user._billing.planId;
						$scope.planSubscribed = (planId !== undefined && planId !== null && planId !== '' && planId !== 'Unset');
					} else {
						$scope.billingSubmitted = false;
						$scope.planSubscribed = false;
					}

					$scope.setVisibility();
				}
            }

        };

		/**
		 * Checks the different parameters and depending on them it hides or
		 * displays the signup-status
		 */
		$scope.setVisibility = function() {
			if($scope.emailVerified === true && $scope.billingSubmitted === true && $scope.planSubscribed === true) {
				$scope.hideMe = true;
			} else if($scope.authentication && $scope.authentication.user && $scope.authentication.user.enterprisePlan){
				$scope.hideMe = true;
			} else if(!$scope.isOwner){
				$scope.hideMe = true;
			} else if(!$stateParams.mobileAppId){
				$scope.hideMe = true;
			} else {
				$scope.hideMe = false;
			}
		};

		/**
		 * Hides/Shows the Signup-Status according to the current state
		 */
		$scope.setPageVisibility = function(stateName) {
			if ($scope.hideStates.indexOf(stateName) !== -1) {
				$scope.stateHideMe = true;
			} else {
				$scope.stateHideMe = false;
			}
		};

        $scope.$on('RefreshSignupStatus', function(event, msg) {
            $scope.init();
        });
		$scope.$watch(function() {return $state.current.name; }, function() {
			$scope.setPageVisibility($state.current.name);
		});
		$scope.$watch(function() {return $stateParams.mobileAppId; }, function() {
			$scope.init();
		});
        $scope.hide = function() {
            $scope.hideMe = !$scope.hideMe;

        };
	}
]);
